
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/Dashboard",
      function () {
        return require("private-next-pages/admin/Dashboard/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/Dashboard"])
      });
    }
  